/**
 * Analytics OpenAPI Specification
 *
 * Generates OpenAPI 3.0 spec for analytics endpoints with /analytics base path.
 */

import { generateOpenApi } from '@ts-rest/open-api';
import { analyticsContract } from './analytics.contract.js';

/**
 * OpenAPI 3.0 specification for Analytics API
 *
 * Generated from ts-rest contract with /analytics base path.
 */
export const analyticsOpenApiSpec = generateOpenApi(
  analyticsContract,
  {
    info: {
      title: 'Skewb Works Analytics API',
      version: '1.0.0',
      description:
        'Type-safe analytics API for Skewb Works application. All endpoints use Zod validation and return typed responses.',
      contact: {
        name: 'Skewb Works Development Team',
      },
    },
    servers: [
      {
        url: 'https://localhost:8080',
        description: 'Local development server',
      },
      {
        url: 'https://api.works-works-lite.dev.skewbdigital.co.uk',
        description: 'Dev API server',
      },
      {
        url: 'https://api.works-works-lite.dev.skewbdigital.co.uk',
        description: 'Production API server',
      },
    ],
    pathPrefix: '/analytics',
    tags: [
      {
        name: 'Analytics',
        description: 'Dashboard analytics and reporting endpoints',
      },
    ],
  },
  {
    setOperationId: true,
    operationMapper: (operation, appRoute) => ({
      ...operation,
      tags: ['Analytics'],
    }),
  },
);
